import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'ca-medium-card',
  templateUrl: 'medium-card.component.html',
  styleUrls: ['medium-card.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CaMediumCardComponent {
  @Input()
  addPadding = true;
}
